import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import { BrowserRouter } from "react-router";

import "tw-elements";

import App from "./App";
import "./index.css";

import { store, changeCompaniesStatus, changeCompanyStatus } from "./store";

import "./firebase";
import { initializeSentry } from "./sentry";

import { AuthProvider } from "./auth";
import { NotificationsProvider } from "./app/useNotifications";
import { ApiProvider } from "./api";
import { ThemeProvider } from "./ui/layout";

initializeSentry();

const persistor = persistStore(store, undefined, () => {
  const dispatch = store.dispatch;
  const state = store.getState();

  if (state.companies.companies.length > 0) {
    dispatch(changeCompaniesStatus("fulfilled"));
  }

  if (state.company.company) {
    dispatch(changeCompanyStatus("fulfilled"));
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <AuthProvider>
          <ApiProvider>
            <NotificationsProvider>
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </NotificationsProvider>
          </ApiProvider>
        </AuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);

export {};
